module.exports = __webpack_public_path__ + "front/img/b43.bf64b5d6.jpg";